import React, { useState, useImperativeHandle } from 'react';
import Slider from '@material-ui/core/Slider';
import { SelectArrow, TickMarkCircle, TickMarkBlankCircle } from './Icons';

const RangeFilterValue = (props) => {

  const {
          filterTitle,
          filterName,
          filterOpen,
          handleFilter,
          valueBounds,
          capacityBounds,
          setIndexValue,
          capacityFilterActive,
          setCapacityFilterActive,
          capacityRangeRef
        } = props;

  const handleChange = (event, newValue) => {
    setIndexValue(newValue);
    setCapacityFilterActive(true);
  };
  const valuetext = (value) => valueBounds[value];
  const handleFilterEntry = () => setCapacityFilterActive(!capacityFilterActive);

  const [valueIndexValueGhost, setValueIndexValueGhost] = useState(valueBounds);

  const handleTemporaryDateChange = (event, newValue) => {
    setValueIndexValueGhost(newValue);
  };

  const resetIndexValueGhost = () => {
    setValueIndexValueGhost([0, capacityBounds[1]]);
  };

  useImperativeHandle(capacityRangeRef, () => {
    return {
      resetIndexValueGhost: resetIndexValueGhost
    };
  });

  const log10 = (x) => {
    return Math.log(x) / Math.log(10);
  }

  return (
    <div className={`filter-tab ${(filterOpen===filterName) ? 'expanded' : 'closed' }`}>
      <div className='filter-expander' id={ filterName } onClick={(e) => handleFilter(e)}>
        <div>
          <h2 className='color-invert'>{ filterTitle }</h2>

          <p className='color-invert'>
            {
              (valueIndexValueGhost[1] === valueBounds[1] && valueIndexValueGhost[0] === valueBounds[0] && !capacityFilterActive) ? 'All Selected' : (
                (!capacityFilterActive) ? 'Multiple Selections' : valueIndexValueGhost[0] + 'MW - ' + ((valueIndexValueGhost[1] === valueBounds[1]) ? valueIndexValueGhost[1] + 'MW+' : valueIndexValueGhost[1] + 'MW') )
            }
          </p>

        </div>
        <SelectArrow className={(filterOpen===filterName) ?  'arrow' : 'arrow-spin-90' }/>
      </div>


      <div className='range-container-wrapper'>
        <div className='range-values'>
          <p className='color-invert'>{valueIndexValueGhost[0]}MW</p>
          <p className='color-invert'>{(valueIndexValueGhost[1] === valueBounds[1]) ? valueIndexValueGhost[1] + 'MW+' : valueIndexValueGhost[1] + 'MW'} </p>
        </div>

        <div className='range-container'>
          <Slider
            min={ 0 }
            max={ capacityBounds[1] }
            step={ 1 }
            scale={ x => log10(x) }
            value={ valueIndexValueGhost }
            getAriaValueText={ valuetext }
            onChangeCommitted={ handleChange }
            onChange={ handleTemporaryDateChange }
            aria-labelledby="value-slider"/>
        </div>

        <div className='filter-select-all flex-container-left' onClick={() => handleFilterEntry()}>
          { !capacityFilterActive && <TickMarkCircle className='inline-style'/> }
          { capacityFilterActive && <TickMarkBlankCircle className='inline-style'/> }

          <p className='color-invert inline-style'>Include Unspecified</p>
        </div>
      </div>
    </div>
  )
}

export default RangeFilterValue;
